import { HOURS_PER_WEEK } from '@/consts';
import { getDateFromHours, getStartingHourForMonth } from './miscUtils';

export const calculateDate = (index, pageIndex, flowRate) => {
  const value = flowRate === HOURS_PER_WEEK ? pageIndex * flowRate : getStartingHourForMonth(pageIndex);

  return getDateFromHours(index + 1 + value);
};
